import CLASettings from '../CLA/CLASettings/CLASettings';
import DutyCodes from '../Settings/DutyCodes/DutyCodes';
import AuxiliaryValues from './AuxiliaryValues/AuxiliaryValues';
import MaxCLASettings from './CLA/MaxCLASettings';
import PremiumPay from './CLA/PremiumPay';
import SalaryScales from './CLA/SalaryScales/SalaryScales';
import DayLimitArrangements from './CLA/DayLimitArrangements/DayLimitArrangements';
import EmployerCostSettingsGrid from './Employer/EmployerCostSettings/EmployerCostSettingsGrid';
import Employers from './Employer/Employers/Employers';
import SurchargeRelationsGrid from './Employer/SurchargeRelations/SurchargeRelationsGrid';
import SurchargesMaintenance from './Employer/SurchargesMaintenance/SurchargesMaintenance';
import PoolMaintenance from './Pools/PoolMaintenance/PoolMaintenance';
import Functions from './Settings/AdminFunctions/Functions';
import Clusters from './Settings/Clusters/Clusters';
import DHTClaSettings from './Settings/DHTClaSettings/DHTClaSettings';
import DTRRules from './Settings/DTRRules/DTRRules';
import DutyHourTypes from './Settings/DutyHourTypes/DutyHourTypes';
import PlanUnits from './Settings/PlanUnits/PlanUnits';
import Qualifications from './Settings/Qualifications/Qualifications';
import Arrangements from './TravelCosts/Arrangements/Arrangements';
import Distances from './TravelCosts/Distances/Distances';
import AgeHours from './Year/AgeHours/AgeHours';
import HolidayHours from './Year/HolidayHours/HolidayHours';
import Holidays from './Year/Holidays/Holidays';
import HolidaySpecial from './Year/HolidaysSpecial/HolidaySpecial';
import TravelDistances from '../TravelDistances';
import TravelMovementsExport from './Settings/TravelMovementsExport/TravelMovementsExport';
import Activities from './Settings/Activities/Activities';
import Resources from './Settings/Resources/Resources';
import Protocols from './Settings/Protocols';
import TreatmentPrograms from './Mrp/TreatmentPrograms/TreatmentPrograms';
import { AdminTableMenusOptions } from './adminTableMenusOptions.enum';
import type { TabType } from '../BaseTabsRouting/types';
import DutyCalculationValueSleepDuty from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/DutyCalculationValueSleepDuty';
import DeclarationTypes from './Settings/DeclarationTypes';
import ClaMaintenance from './CLA/ClaMaintenance';

export const adminTableViews: TabType[] = [
  {
    name: 'CLUSTERS',
    Component: Clusters,
    parent: AdminTableMenusOptions.SETTINGS,
    grants: ['hasClustersOrgGrant']
  },
  {
    name: 'FUNCTIONS',
    Component: Functions,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DUTY_CODES',
    Component: DutyCodes,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DUTY_HOUR_TYPES',
    Component: DutyHourTypes,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'QUALIFICATIONS',
    Component: Qualifications,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'SALARY_COMPONENT',
    Component: DHTClaSettings,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'AUXILIARY_VALUES',
    Component: AuxiliaryValues,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DECLARATION_TYPES',
    Component: DeclarationTypes,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DTR_RULES',
    Component: DTRRules,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'PLAN_UNITS',
    Component: PlanUnits,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'TRAVEL_MOVEMENTS_EXPORT',
    Component: TravelMovementsExport,
    parent: AdminTableMenusOptions.SETTINGS,
    grants: ['hasTravelMovementsFeature', 'hasFeatureToggleExpenseClaims']
  },
  {
    name: 'ACTIVITIES',
    Component: Activities,
    parent: AdminTableMenusOptions.SETTINGS,
    grants: ['hasManageActivities']
  },
  {
    name: 'RESOURCES',
    Component: Resources,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'PROTOCOLS',
    Component: Protocols,
    parent: AdminTableMenusOptions.SETTINGS,
    grants: ['hasFeatureToggleProtocols']
  },
  {
    name: 'HOLIDAY',
    Component: Holidays,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'HOLIDAY_SPECIAL',
    Component: HolidaySpecial,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'HOLIDAY_HOURS',
    Component: HolidayHours,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'AGE_HOURS',
    Component: AgeHours,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'ARRANGEMENTS',
    Component: Arrangements,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'DISTANCES',
    Component: Distances,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'TRAVEL_DISTANCES',
    Component: TravelDistances,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'EMPLOYERS',
    Component: Employers,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'EMPLOYERS_COST_SETTINGS',
    Component: EmployerCostSettingsGrid,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'SURCHARGES_MAINTENANCE',
    Component: SurchargesMaintenance,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'SURCHARGES_RELATIONS',
    Component: SurchargeRelationsGrid,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'POOL_MAINTENANCE',
    Component: PoolMaintenance,
    parent: AdminTableMenusOptions.POOLS
  },
  {
    name: 'CLA',
    Component: CLASettings,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'MAX_CLA_SETTINGS',
    Component: MaxCLASettings,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'SALARY_SCALES',
    Component: SalaryScales,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'DAY_LIMIT_ARRANGEMENTS',
    Component: DayLimitArrangements,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'ORT',
    Component: PremiumPay,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'CALCULATION_VALUE_SLEEPDUTY',
    Component: DutyCalculationValueSleepDuty,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'TREATMENT_PROGRAMS',
    Component: TreatmentPrograms,
    parent: AdminTableMenusOptions.MRP,
    grants: ['hasMultiResourcePlanningModule']
  },
  {
    name: 'CLA_MAINTENANCE',
    Component: ClaMaintenance,
    parent: AdminTableMenusOptions.SERVICEDESK
  }
];
